<template>
  <v-row style="height: 100vh">
    <div class="text-box">
      <h1>Der Erhebungszeitraum für diese Umfrage ist abgelaufen.</h1>
      <h3>Eine Teilnahme ist leider nicht mehr möglich.</h3>
      <br />
      <h1>The response period for this survey has ended.</h1>
      <h3>Unfortunately it is no longer possible to take part.</h3>
    </div>
    <v-col cols="2" class="box-1"></v-col>
    <v-col cols="2" class="box-2"></v-col>
    <v-col cols="2" class="box-3"></v-col>
    <v-col cols="1" class="box-4"></v-col>
    <v-col cols="2" class="box-5"></v-col>
    <v-col cols="1" class="box-6"></v-col>
    <v-col cols="2" class="box-7"></v-col>
  </v-row>
</template>

<script>
export default {
  name: "QuestionnaireExpiredView",
  computed: {
    name() {
      return this.$store.getters["contact/getName"];
    },
    email() {
      return this.$store.getters["contact/getEmail"];
    },
  },
};
</script>

<style scoped>
.text-box {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  text-align: center;
}

.box-1 {
  background-color: #4ca1c4;
}
.box-2 {
  background-color: #4c874c;
}
.box-3 {
  background-color: #edc84c;
}
.box-4 {
  background-color: #bb584c;
}
.box-5 {
  background-color: #c75e61;
}
.box-6 {
  background-color: #9c4c4c;
}
.box-7 {
  background-color: #f49c53;
}
</style>
